// ====================================================================================
// COMPONENT: KPILinks (Aesthetic: Glass Action Cards - White Accents)
// Self-contained with all icons and logic.
// ====================================================================================
import {
  SlidersHorizontal,
  UploadCloud,
  Image as ImageIcon,
  ClipboardList,
  AlertTriangle,
} from "lucide-react";

const getKpiLinks = (setActiveView, setShowImageUpload, setShowSurveyDialog) => [
  { name: 'Simulate Campaign', icon: SlidersHorizontal, action: () => setActiveView('plato') },
  { name: 'Upload Images', icon: UploadCloud, action: () => setShowImageUpload(true) },
  { name: 'View Gallery', icon: ImageIcon, action: () => setActiveView('gallery') },
  { name: 'Survey Links', icon: ClipboardList, action: () => setShowSurveyDialog(true) },
  { name: 'Report Issue', icon: AlertTriangle, action: () => setActiveView('localIssues') },
];

const KPILinks = ({ setActiveView, setShowImageUpload, setShowSurveyDialog }) => {
  const kpiLinks = getKpiLinks(setActiveView, setShowImageUpload, setShowSurveyDialog);

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
      {kpiLinks.map((link) => (
        <div
          key={link.name}
          onClick={link.action}
          className="bg-slate-900/40 border border-slate-700/50 hover:bg-slate-800/60 hover:border-white/30 rounded-xl p-4 flex flex-col items-center justify-center text-center gap-3 cursor-pointer group transition-all duration-300 hover:shadow-[0_0_20px_-5px_rgba(255,255,255,0.1)] relative overflow-hidden"
        >
          {/* Subtle Hover Gradient (White) */}
          <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

          <div className="relative p-3 rounded-full bg-slate-950/50 border border-slate-800 group-hover:border-white/40 group-hover:text-white text-slate-400 transition-all duration-300 shadow-inner">
            <link.icon size={20} />
          </div>
          <span className="relative text-[10px] font-bold text-slate-300 group-hover:text-white transition-colors uppercase tracking-widest">{link.name}</span>
        </div>
      ))}
    </div>
  );
};

export default KPILinks;
